module.exports = __webpack_public_path__ + "static/media/poste_8.4a34ed8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_8.jpg
// module id = 265
// module chunks = 0